import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App";
import { ErrorBoundary } from "./components/ErrorBoundary";
import { useThemeStore } from "./stores/themeStore";

// Initialise the theme store and subscribe to OS-level color-scheme changes.
// The store applies the cached mode to <html data-theme> in its constructor,
// so the first paint already matches the user's last choice.
useThemeStore.getState().watchSystem();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </StrictMode>
);
